var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.style),attrs:{"id":"module-container"}},[_c('div',{staticClass:"container-module-header"},[_c('header',{staticClass:"module-header-text"},[_vm._v(_vm._s(_vm.title))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }